import type { FunctionComponent } from 'react';

import { Tooltip } from '~/ui/core/tooltip/Tooltip';

import type { JobItemDetails } from '../../api/use-job-item-details';
import { Initials, ReviewerBadge } from '../../components/Status';

/**
 * The compact reviewer chip used on the left side of the prompt's
 * context row. Shares geometry with the Status component so the prompt
 * reads as a sibling of the role panel's metadata badge.
 */
export const ReviewerLeading: FunctionComponent<{ readonly item: Pick<JobItemDetails, 'reviewer'> }> = ({ item }) => (
    <Tooltip>
        <Tooltip.Trigger asChild={true}>
            <ReviewerBadge data-testid="reviewer-badge" isActive={false}>
                <Initials profile={item} />
            </ReviewerBadge>
        </Tooltip.Trigger>
        {item.reviewer !== undefined && (
            <Tooltip.Content side="top">
                {item.reviewer?.firstName} {item.reviewer?.lastName}
            </Tooltip.Content>
        )}
    </Tooltip>
);
